<template>
  <div v-if="cart.room">
    <div class="brecrump font-bai">
      <router-link to="/">{{$t('app.Home')}}</router-link>/
      <router-link to="/result">{{$t('app.Recherche')}}</router-link>/
      <router-link :to="`/room/${cart.room.Id}`">{{getTranslate(cart.room.Name)}}</router-link>/
      <b>{{$t('app.Panier')}}</b>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="payment-left">
          <h1 class="font-bold font-balo">{{$t('app.Services et options')}}</h1>
          <div class="payment-options" v-if="checkboxOptions.length">
            <h2 class="font-bai font-bold">{{$t('app.Options')}}</h2>
            <ul class="services-list">
              <li v-for="(item, index) in checkboxOptions" :key="index">
                <label
                  class="checkbox-custom font-bai pointer"
                  @click.prevent="onAddProductToCart(item)"
                  :class="{'active': isAddedProduct(item)}"
                >
                  <div class="des">
                    <h4>{{getTranslate(item.Name)}}</h4>
                  </div>
                </label>
              </li>
            </ul>
          </div>
          <div class="payment-restaurant" v-if="imageOptions.length">
            <h2 class="font-bai font-bold">{{$t('app.Restauration')}}</h2>
            <ul class="restaurant-list">
              <li v-for="(item, index) in imageOptions" :key="index">
                <CartItem :item="item" :cartProducts="cartProducts" :onGetPricing="onGetPricing" />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <CartSidebar />
      </div>
    </div>
  </div>
</template>

<script>
import CartItem from "@/components/cart/CartItem";
import CartSidebar from "@/components/cart/CartSidebar";
import { mapState, mapActions } from "vuex";
import { get, filter, find, map } from "lodash";
import { OPTIONS } from "@/helper/config";
import { CDN_MEWS_MEDIA } from "@/api/config";
import moment from "moment";
export default {
  name: "CartServiceOptions",
  components: { CartItem, CartSidebar },
  data() {
    return {
      checkboxOptions: [],
      imageOptions: []
    };
  },
  computed: {
    ...mapState({
      mewsProducts: state => get(state, "hotels.hotels.Products", []),
      cartProducts: state => get(state, "cart.cart.products", []),
      cart: state => get(state, "cart.cart"),
      lang: state => get(state, "app.lang", "fr"),
      currency: state => get(state, "app.currency")
    })
  },
  mounted() {
    // const mewsProducts
    let checkboxOptions = [];
    let imageOptions = [];
    filter(get(this.cart, "room.info.options", []), option =>
      find(this.mewsProducts, item => item.Id == option.reference)
    ).forEach(option => {
      const mewsProduct = find(
        this.mewsProducts,
        item => item.Id === option.reference
      );
      const optionData = {
        category: Number(option.category) || 1,
        ...mewsProduct
      };
      if (optionData.category === OPTIONS.checkbox) {
        checkboxOptions.push(optionData);
      }
      if (optionData.category === OPTIONS.image) {
        imageOptions.push(optionData);
      }
    });
    this.checkboxOptions = checkboxOptions;
    this.imageOptions = imageOptions;
  },
  methods: {
    ...mapActions("cart", ["setStep", "addProductToCart", "getPricing"]),

    getTranslate(object) {
      if (this.lang === "fr" && get(object, "fr-FR")) {
        return get(object, "fr-FR");
      }
      return get(object, "en-US");
    },
    getImageUri(image) {
      return `${CDN_MEWS_MEDIA}/Image/${image}?Mode=Fit&Height=161`;
    },
    onAddProductToCart(item) {
      this.addProductToCart(item).then(() => {
        this.onGetPricing();
      });
    },
    isAddedProduct(item) {
      return find(this.cartProducts, product => product.Id === item.Id);
    },
    onGetPricing() {
      const child = this.cart.info.child || 0;
      const child1 = this.cart.info.child1 || 0;
      const dataPricing = {
        StartUtc: moment(new Date(this.cart.info.dateFrom)).toISOString(true),
        EndUtc: moment(new Date(this.cart.info.dateTo)).toISOString(true),
        RoomCategoryId: this.cart.room.RoomCategoryId,
        Occupancies: [
          {
            AdultCount: this.cart.info.adult || 0,
            ChildCount: child + child1 || 0
          }
        ]
      };
      if (this.cart.voucher) {
        dataPricing.VoucherCode = this.cart.voucher;
      }
      if (this.cart.products && this.cart.products.length) {
        dataPricing.ProductIds = map(this.cart.products, product => product.Id);
      }
      this.getPricing(dataPricing);
    }
  }
};
</script>
